var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOklahoma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.053,129.337v-10.065v-5.691l-1.465-4.391l-1.635-4.908v-0.667V84.911c-95.828,1.55-202.504-4.392-202.504-4.392 c-8.507-0.144-17.819-0.527-27.61-1.088l-1.444,18.081L24.46,109.19h84.334l-2.041,58.503l10.074,8.523l3.1-3.488l8.91,1.938 l-0.385,5.812c0,0,13.172,3.1,17.434,5.424s8.912-0.775,11.236,0c2.326,0.774,6.973,9.686,9.299,10.072 c2.324,0.389,6.586-3.486,9.299-3.592c2.711-0.104,8.91,7.469,10.459,7.854c1.551,0.388,3.875-6.587,5.813-7.756 c1.937-1.169,18.211,8.531,20.146,8.531c1.939,0,2.326-3.875,3.875-5.038c1.551-1.162,5.424-0.387,10.072-0.773 c4.65-0.389,13.563-2.326,16.619-2.713c0.715-0.09,2.277,0.656,4.262,1.82l-0.868,13.397l16.538,0.409v-3.957V144.06 L260.053,129.337z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOklahoma);
export default __webpack_public_path__ + "static/media/oklahoma.98dcc409cf5e8650e7e96a47872d9bbb.svg";
export { ForwardRef as ReactComponent };